import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@environment/environment';

@Injectable()
export class ApiUrlInterceptor implements HttpInterceptor {
  intercept(
    request: HttpRequest<Request>,
    next: HttpHandler,
  ): Observable<HttpEvent<Event>> {
    if (request.url.startsWith('http')) {
      return next.handle(request);
    }

    const apiRequest = request.clone({
      url: `${environment.apiUrl}${request.url}`,
    });

    return next.handle(apiRequest);
  }
}
